import { createRouter, RouteRecordRaw, createWebHistory,createWebHashHistory } from 'vue-router';

// export const layoutRoutes: Array<RouteRecordRaw> = [

// ];


const routes: Array<RouteRecordRaw> = [


  // {
  //   path: '/',
  //   name: 'home',
  //   component: () => import('@/pages/home/index.vue'),
  //   redirect: '/home',
  //   children: [
  //     {
  //       path: '/home',
  //       name: 'home',
  //       component: () => import('@/pages/home/index.vue')
  //     },
      
  //   ]
  // },


  {
    path: '/', // 根路由路径
    redirect: '/home' // 重定向到 /home 路径
  },
  {
    path: '/home',
    name: 'Home',
    meta: {
      title: 'home',
      // isKeepAlive: true
    },
    component: () => import('@/pages/home/index.vue'),
  },
  {
    path: '/adverPage',
    name: 'adverPage',
    meta: {
      title: 'adverPage',
    },
    component: () => import('@/pages/home/adverPage.vue'),
  },
  {
    path: '/marketPage',
    name: 'marketPage',
    meta: {
      title: 'marketPage',
    },
    component: () => import('@/pages/home/marketPage.vue'),
  },
  {
    path: '/guideDown',
    name: 'guideDown',
    meta: {
      title: 'guideDown',
    },
    component: () => import('@/pages/guideIos/guideDown.vue'),
  },
   {
    path: '/guidePage',
    name: 'guidePage',
    meta: {
      title: 'guidePage',
    },
    component: () => import('@/pages/guideIos/guidePage.vue'),
  },
  {
    path: '/infoWish',
    name: 'infoWish',
    meta: {
      title: 'infoWish',
    },
    component: () => import('@/pages/userinfo/infoWish.vue'),
  },
  {
    path: '/infoSelf',
    name: 'infoSelf',
    meta: {
      title: 'infoSelf',
    },
    component: () => import('@/pages/userinfo/infoSelf.vue'),
  },
  {
    path: '/infoJob',
    name: 'infoJob',
    meta: {
      title: 'infoJob',
    },
    component: () => import('@/pages/userinfo/infoJob.vue'),
  },
  {
    path: '/infoContact',
    name: 'infoContact',
    meta: {
      title: 'infoContact',
    },
    component: () => import('@/pages/userinfo/infoContact.vue'),
  },
  {
    path: '/infoCard',
    name: 'infoCard',
    meta: {
      title: 'infoCard',
    },
    component: () => import('@/pages/userinfo/infoCard.vue'),
  },
  {
    path: '/infoOcr',
    name: 'infoOcr',
    meta: {
      title: 'infoOcr',
    },
    component: () => import('@/pages/userinfo/infoOcr.vue'),
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'login',
    },
    beforeEnter: (to, from, next) => {
      const name = from.name as string;
      if (["adverPage"].includes(name)) {
        to.params.from = "adverPage";
      } else if (["marketPage"].includes(name)) {
        to.params.from = "marketPage";
      }  else {
        to.params.from = "other";
      }
      next();
    }, 
    component: () => import('@/pages/login/index.vue'),
  },
    {
    path: '/loginIos',
    name: 'loginIos',
    meta: {
      title: 'loginIos',
    },
    component: () => import('@/pages/loginIos/index.vue'),
  },
  
  {
    path: '/setPassword',
    name: 'setPassword',
    meta: {
      title: 'setPassword',
    },
    component: () => import('@/pages/login/setPassword.vue'),
  },
  {
    path: '/setPasswordIn',
    name: 'setPasswordIn',
    meta: {
      title: 'setPasswordIn',
    },
    component: () => import('@/pages/login/setPasswordIn.vue'),
  },
    {
    path: '/userCenter',
    name: 'userCenter',
    meta: {
      title: 'userCenter',
    },
    component: () => import('@/pages/userCenter/index.vue'),
  },
  {
    path: '/orderList',
    name: 'orderList',
    meta: {
      title: 'orderList',
    },
    component: () => import('@/pages/userCenter/orderList.vue'),
  },
  {
    path: '/userMsg',
    name: 'userMsg',
    meta: {
      title: 'userMsg',
    },
    component: () => import('@/pages/userCenter/userMsg.vue'),
  },
  {
    path: '/updateCard',
    name: 'updateCard',
    meta: {
      title: 'updateCard',
    },
    component: () => import('@/pages/modify/updateCard.vue'),
  },
  {
    path: '/updateCardFail',
    name: 'updateCardFail',
    meta: {
      title: 'updateCardFail',
    },
    component: () => import('@/pages/modify/updateCardFail.vue'),
  },
  {
    path: '/repayDetail',
    name: 'repayDetail',
    meta: {
      title: 'repayDetail',
    },
    component: () => import('@/pages/repay/detail.vue'),
  },
  {
    path: '/repayPse',
    name: 'repayPse',
    meta: {
      title: 'repayPse',
    },
    component: () => import('@/pages/repay/pse.vue'),
  },
  {
    path: '/repayNequi',
    name: 'repayNequi',
    meta: {
      title: 'repayNequi',
    },
    component: () => import('@/pages/repay/nequi.vue'),
  },
  {
    path: '/repayEfectivo',
    name: 'repayEfectivo',
    meta: {
      title: 'repayEfectivo',
    },
    component: () => import('@/pages/repay/efectivo.vue'),
  },
  {
    path: '/repayDelay',
    name: 'repayDelay',
    meta: {
      title: 'repayDelay',
    },
    component: () => import('@/pages/repay/repayDelay.vue'),
  },
  {
    path: '/efectivoOut',
    name: 'efectivoOut',
    meta: {
      title: 'efectivoOut',
    },
    component: () => import('@/pages/repay/efectivoOut.vue'),
  },

  {
    path: '/loanPact',
    name: 'loanPact',
    meta: {
      title: 'loanPact',
    },
    component: () => import('@/pages/pryText/loanPact.vue'),
  },
  {
    path: '/userPact',
    name: 'userPact',
    meta: {
      title: 'userPact',
    },
    component: () => import('@/pages/pryText/userPact.vue'),
  },
  {
    path: '/transfiyaPay',
    name: 'transfiyaPay',
    meta: {
      title: 'transfiyaPay',
    },
    component: () => import('@/pages/repay/transfiyaPay.vue'),
  },
  {
    path: '/assetsRules',
    name: 'assetsRules',
    meta: {
      title: 'assetsRules',
    },
    component: () => import('@/pages/assetsRules/index.vue'),
  },
  
  
  {
    path: '/feedback',
    name: 'feedback',
    meta: {
      title: 'feedback',
    },
    component: () => import('@/pages/feedback/index.vue'),
  },
  {
    path: '/feedbackForm',
    name: 'feedbackForm',
    meta: {
      title: 'feedbackForm',
    },
    component: () => import('@/pages/feedback/form.vue'),
  },
  {
    path: '/feedbackDetails',
    name: 'feedbackDetails',
    meta: {
      title: 'feedbackDetails',
    },
    component: () => import('@/pages/feedback/details.vue'),
  },
  {
    path: '/feedbackEvaluate',
    name: 'feedbackEvaluate',
    meta: {
      title: 'feedbackEvaluate',
    },
    component: () => import('@/pages/feedback/evaluate.vue'),
  },
  
  { path: '/:pathMatch(.*)*', redirect: '/home' },
];

const router = createRouter({
  history: location.href.indexOf('//webapp.morloan.co') >= 0 ? createWebHistory() : createWebHashHistory(), 
  routes,
});
export default router;
